/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PublicAlert
 */
export interface PublicAlert {
    /**
     * 
     * @type {string}
     * @memberof PublicAlert
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof PublicAlert
     */
    'severity': PublicAlertSeverityEnum;
    /**
     * ISO-8601 timestamp начала инцидента
     * @type {string}
     * @memberof PublicAlert
     */
    'since': string;
}

export const PublicAlertSeverityEnum = {
    Critical: 'CRITICAL',
    Warning: 'WARNING',
    Info: 'INFO'
} as const;

export type PublicAlertSeverityEnum = typeof PublicAlertSeverityEnum[keyof typeof PublicAlertSeverityEnum];


